<template>  
<el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">公告 </span>
      </template>
    </el-page-header>
  </el-form>
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
    <el-table
      :data="tableData"
      v-loading="loadingData"
      class="mainTable"
      row-key="noticeid"
      stripe
    >
      <el-table-column label="标题" prop="title">
        <template #default="scope">
          <el-link
            @click="open('noticeDetail',scope.row.noticeid)"
            v-text="scope.row.title"
          />
        </template>
      </el-table-column>
      <el-table-column label="发布日期" prop="published">
        <template #default="scope">
          <span
            v-text="util.formatDateUnix(scope.row.published, 'yyyy-MM-dd')"
          ></span>
        </template>
      </el-table-column>
    </el-table>
    </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8"><div>
          <!-- <el-button
            type="danger"
            >添加用户</el-button> -->
        </div></el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="true"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
  </template>
      
    <script setup>
    import { useRouter } from "vue-router";

  import { ref, onMounted } from "vue";
  import { ElTable } from "element-plus";
  import { listNotice} from "@/api/notice";
  
  import util from "@/util/tool.js";

  const router = useRouter();

  let open = (routeName, row) => {
  console.log(row)
  if (row === 'more') {
    router.push({
      name: routeName,
    });
  } else {
    router.push({
      name: routeName,
      params: { id: row },
    });
  }
};
  
  const loadingData = ref(true);
  
  
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  const goback = () => {
    router.go(-1);
  };
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    title: '',
    status: '',
  });
  
  
  const tableData = ref([]);
  
  //onMounted方法
  onMounted(() => {
    getListNotice();
  });
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListNotice();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListNotice();
  };
  
  //公告表API
  const getListNotice = () => {
    listNotice(queryParam.value).then((res) => {
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      tableData.value = res.data.extend.pages.list;
      loadingData.value = false
    });
  };
  
  </script>